var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "marker arrow-bottom",
      class: { hover: _vm.isHovered({ building: _vm.building.id }) },
      style: { borderLeftColor: _vm.priceColor(_vm.building.averagePrice) }
    },
    [
      _c("p", { staticClass: "t12 u-cut" }, [
        _vm._v(_vm._s(_vm.building.name) + ".")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "t15 u-cut w7" }, [
        _vm._v(_vm._s(_vm._f("price")(_vm.building.averagePrice)) + "円")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }